/*! License details at fancyapps.com/license */
const t=t=>"object"==typeof t&&null!==t&&t.constructor===Object&&"[object Object]"===Object.prototype.toString.call(t);export{t as isPlainObject};
